
import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IAccelerationTask } from '../types/IAccelerationTask';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { ISiteNameWithId } from '../types/ISiteNameWithId';
import { IUser } from '../types/IUser';
import { IView } from '../types/IView';
import { INamedItem } from '../types/resourceParts';

export interface IGetAccelerationTasksResult extends IGetItemsResult {
  tasks: IAccelerationTask[];
  workbooks: INamedItem[];
  users: IUser[];
  views: IView[];
  projects: INamedItem[];
  sites: ISiteNameWithId[];
}

export class GetAccelerationTasksRequest extends Request<IGetItemsParams, IGetAccelerationTasksResult> {
  constructor(params: IGetItemsParams) {
    super('getAccelerationTasks', params);
  }
}
